module.exports = __webpack_public_path__ + "img/a061c6d.jpg";